import { createAction, props, union } from '@ngrx/store';

import { ChangeTypeEnum } from '@global/infrastructure/enums/change-type.enum';

export const loadExistingContacts = createAction(
  '[Your Drivers] Load Existing Contacts',
  props<{ policyNumber: number }>()
);

export const loadExistingContactsSucceeded = createAction(
  '[Your Drivers] Load Existing Contacts Succeeded',
  props<{ existingContacts: any }>()
);

export const addDriver = createAction(
  '[Your Drivers] Add Driver',
  props<{ driver: any, changeType?: ChangeTypeEnum }>()
);

export const updateDriver = createAction(
  '[Your Drivers] Update Driver',
  props<{ driver: any, id: number, changeType: ChangeTypeEnum }>()
);

export const updateContactDriver = createAction(
  '[Your Drivers] Update Contact Driver',
  props<{ driver: any, id: number, changeType: ChangeTypeEnum }>()
);
export const removeNewDriver = createAction(
  '[Your Drivers] Remove New Driver',
  props<{ index: number, driverId: string, changeType: ChangeTypeEnum }>()
);

export const updateAdditionalDetails = createAction(
  '[Your Drivers] Update Additional Details',
  props<{ additionalDetails: any}>()
);

export const clearAllDriversAfterSuccessfulPremium = createAction(
  '[Your Drivers] Clear All Permanent Drivers After Successful Premium'
);

export const removeExistingDriver = createAction(
  '[Your Drivers] Remove Existing Driver',
  props<{ driverId: string, changeType: ChangeTypeEnum}>()
);

export const updateManagedDriverDetails = createAction(
  '[Your Drivers] Update Managed Driver Details',
  props<{ driverDetails: any }>()
);

export const setIsProvisional = createAction(
  '[Your Drivers] Update provisional licence flag',
  props<{ isProvisional: boolean }>()
);

export const cancelManagedDriver = createAction(
  '[Your Drivers] Cancel Managed Driver'
);

export const clearManagedDriverDlnDetails = createAction(
  '[Your Drivers] Clear Managed Driver Dln Details'
);

export const editManagedDriverDetails = createAction(
  '[Your Drivers] Edit Managed Driver Details',
  props<{ id: string, changeType: ChangeTypeEnum }>()
);

export const moveManagedDriverToList = createAction(
  '[Your Drivers] Move Managed Driver To List',
  props<{ changeType: ChangeTypeEnum }>()
);

export const clearManagedDriverDetails = createAction(
  '[Your Drivers] Clear Managed Driver Details'
);

export const copyToManagedDriver = createAction(
  '[Your Drivers] Copy To Managed Driver',
  props<{ id: string, changeType: ChangeTypeEnum }>()
);

export const updateDriverList = createAction(
  '[Your Drivers] Update Driver List',
  props<{ drivers: any[] }>()
);

const all = union({
  addDriver,
  updateDriver,
  removeNewDriver,
  updateAdditionalDetails,
  removeExistingDriver,
  clearAllDriversAfterSuccessfulPremium,
  updateManagedDriverDetails,
  cancelManagedDriver,
  clearManagedDriverDlnDetails,
  copyToManagedDriver,
  updateDriverList
});
export type YourDriversActionsUnion = typeof all;
